export default __webpack_public_path__ + "static/trent-forecasting-1f503010ef647e817accbbdf5dfb5cb2.png";